import { DevicesAPI, IGetRoomDevicesParams } from "../../services/hcnApi";

export const getRoomDevicesUseCase = async (params: IGetRoomDevicesParams) => {
  return await DevicesAPI.getRoomDevices(params);
};
